import { InjectionToken } from '@angular/core';
import { ITranslationLanguage } from '@app-core/interfaces/language.interface';

export const NGQ_LANGUAGES_TOKEN = new InjectionToken<ITranslationLanguage>(
  'List of languages',
);
